import React, { useEffect } from "react";
import styled from "styled-components";
import { Col } from "module/common/component/layout";

export interface ModalProps {
    open: boolean;
    onClose?: () => void;
    children?: React.ReactNode;
    closeOnOverlayClick?: boolean;
    style?: React.CSSProperties;
    className?: string;
}

const ModalOverlay = styled.div<{ open: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: ${({ open }) => (open ? "flex" : "none")};
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

const ModalContent = styled(Col)`
    background-color: ${({ theme }) => theme.palette.white};
    border-radius: 0.5rem;
    padding: 2rem;
    max-width: 90vw;
    max-height: 90vh;
    overflow: auto;
`;

export const Modal: React.FC<ModalProps> = ({ open, onClose, children, closeOnOverlayClick = true, style, className }) => {
    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [open]);

    if (!open) return null;

    return (
        <ModalOverlay
            open={open}
            onClick={closeOnOverlayClick ? onClose : undefined}
        >
            <ModalContent onClick={(e) => e.stopPropagation()} style={style} className={className}>{children}</ModalContent>
        </ModalOverlay>
    );
};

export default Modal;


